module.exports = __webpack_public_path__ + "img/carretas.f70eb8ea.svg";